export default __webpack_public_path__ + "static/media/003-hot air balloon.9b7286d7.svg";